/* =====================================================================
   JOIEX v7 colour modes (deferred, every page)
   <html data-theme> is already set before first paint by the inline script
   in layout/theme.liquid. This file runs the header sun/moon switcher
   ([data-theme-toggle]), remembers the choice (localStorage "joiex_theme"),
   follows other tabs and, when the default is "system", the device setting
   until the visitor picks a mode.
   The switch is a circle reveal from the button (View Transitions), a short
   colour crossfade elsewhere, and instant under reduced motion.
   Fires "joiex:themechange" on document with detail.mode.
   Debug handle: window.JXMode.
   ===================================================================== */
(function () {
  'use strict';
  if (window.JXMode) return;

  var d = document;
  var de = d.documentElement;
  var KEY = 'joiex_theme';
  var mm = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
  var mqReduce = mm('(prefers-reduced-motion: reduce)');
  var mqLight = mm('(prefers-color-scheme: light)');

  function get() { return de.getAttribute('data-theme') === 'light' ? 'light' : 'dark'; }
  function stored() {
    try {
      var v = window.localStorage.getItem(KEY);
      return v === 'light' || v === 'dark' ? v : '';
    } catch (e) { return ''; }
  }
  function store(m) {
    try { window.localStorage.setItem(KEY, m); } catch (e) { /* storage blocked: this page view only */ }
  }

  /* button labels name the action; the browser UI colour follows the header */
  function sync() {
    var m = get();
    var meta = d.querySelector('meta[name="theme-color"]');
    var c = meta && meta.getAttribute('data-' + m);
    if (c) meta.setAttribute('content', c);
    var btns = d.querySelectorAll('[data-theme-toggle]');
    for (var i = 0; i < btns.length; i++) {
      var label = btns[i].getAttribute(m === 'dark' ? 'data-label-light' : 'data-label-dark');
      if (label) btns[i].setAttribute('aria-label', label);
    }
  }

  function apply(m) {
    if (m !== 'light' && m !== 'dark') return;
    if (m === get()) { sync(); return; }
    de.setAttribute('data-theme', m);
    de.style.colorScheme = m;
    sync();
    var ev;
    try {
      ev = new CustomEvent('joiex:themechange', { detail: { mode: m } });
    } catch (e) {
      ev = d.createEvent('CustomEvent');
      ev.initCustomEvent('joiex:themechange', false, false, { mode: m });
    }
    d.dispatchEvent(ev);
  }

  var fadeT = 0;
  function change(m, origin) {
    if (m === get()) { sync(); return; }
    if (mqReduce.matches || d.hidden) { apply(m); return; }

    /* while the page steps between sections or the product flies, a snapshot would freeze
       one scroll position against the moving page, so the colours crossfade instead */
    var jm = window.JXMotion;
    var moving = !!(jm && ((jm.snap && jm.snap.anim) || (jm.flight && jm.flight.state === 'fly')));
    if (origin && !moving && typeof d.startViewTransition === 'function' && de.animate) {
      var r = origin.getBoundingClientRect();
      var x = r.left + r.width / 2;
      var y = r.top + r.height / 2;
      var end = Math.ceil(Math.sqrt(Math.pow(Math.max(x, window.innerWidth - x), 2) +
        Math.pow(Math.max(y, window.innerHeight - y), 2)));
      var vt;
      try {
        vt = d.startViewTransition(function () { apply(m); });
      } catch (e) {
        apply(m);
        return;
      }
      vt.ready.then(function () {
        de.animate(
          { clipPath: ['circle(0px at ' + x + 'px ' + y + 'px)', 'circle(' + end + 'px at ' + x + 'px ' + y + 'px)'] },
          { duration: 720, easing: 'cubic-bezier(.65,0,.35,1)', pseudoElement: '::view-transition-new(root)' }
        );
      }).catch(function () { /* skipped transition: the mode is already applied */ });
      return;
    }

    de.classList.add('jx-mode-fade');
    apply(m);
    clearTimeout(fadeT);
    fadeT = setTimeout(function () { de.classList.remove('jx-mode-fade'); }, 520);
  }

  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-theme-toggle]') : null;
    if (!b) return;
    var next = get() === 'dark' ? 'light' : 'dark';
    store(next);
    change(next, b);
  });

  window.addEventListener('storage', function (e) {
    if (e.key === KEY && (e.newValue === 'light' || e.newValue === 'dark')) apply(e.newValue);
  });

  var onSystem = function () {
    if (de.getAttribute('data-theme-default') === 'system' && !stored()) change(mqLight.matches ? 'light' : 'dark');
  };
  if (mqLight.addEventListener) mqLight.addEventListener('change', onSystem);
  else if (mqLight.addListener) mqLight.addListener(onSystem);

  d.addEventListener('shopify:section:load', sync);
  sync();

  window.JXMode = {
    get: get,
    set: function (m) { store(m); change(m); }
  };
})();
